export const babiesActionTypes = {
  STORE_BABIES_DETAILS: "STORE_BABIES_DETAILS",
  STORE_BABY_DETAILS: "STORE_BABY_DETAILS",
  SEARCH_FOR_BABIES: "SEARCH_FOR_BABIES",
};
